import React from "react";
import {ContentAuth, CardAuth, SectionSeparator} from "./components/AuthStyles";
import {Content} from "../../styles/GlobalStyles";
import Header from "../../components/header/Header";
import Color from "../../assets/Colors";
import Footer from "../../components/footer/Footer";
import ContactForm from "../../components/contact/ContactForm";
import {CardContactMap, SubtitleContact, TextContact, TitleContact, MapContact} from "./components/ContactStyles";
import MapComponent from "./components/MapComponent";

export default function ContactView() {
   return (
      <>
         <Header normal={true} secondary={Color.primary} primary={Color.primary} logoInvert={true} classname="invert" />
         <Content>
            <ContentAuth />
            <CardAuth align="flex-start">
               <div className="styleCardContact">
                  <TitleContact> Ponte en contacto</TitleContact>
                  <TextContact>
                     Si estás interesado en alguno de nuestros programas, <br /> escríbenos un comentario o visítanos, <br /> puedes hacer
                     contacto por los diferentes canales que ponemos a tu disposición.
                  </TextContact>
                  <br />
                  <TextContact>
                     Teléfono
                     <br />
                     (55) 6819-2323
                  </TextContact>
                  <br />
                  <TextContact>
                     ¿Tienes alguna duda? Visita nuestra sección de{" "}
                     <a href="/preguntas_frecuentes" className="textLink">
                        Preguntas Frecuentes
                     </a>{" "}
                     o ponte en contacto con nosotros.
                  </TextContact>
               </div>
            </CardAuth>
         </Content>

         <CardAuth>
            {/* <MapContact /> */}
            <MapComponent />
            <div style={{width: "90vw", margin: "0 auto"}}>
               <SectionSeparator />
            </div>
            <Content> 
               <ContactForm width="100%" centerBtn={false} title="Ponte en contacto" type="contacto" />
            </Content>
         </CardAuth>
         <Footer />
      </>
   );
}

// src\assets\image\views\map_domecq.png
